module.exports = {"message":"你好 i18n !!","cutLocalImage":"裁剪本地图片","choseImage":"选择图片","showAfterProcess":"裁剪后显示在这里","downloadNewImage":"下载图片","submit":"确定","reset":"重置","trunLeft":"左转","trunRight":"右转","cancel":"取消","mainTitle":"在线裁剪&旋转图片","txtDescription":"使用此工具进行图片裁剪或旋转图片。"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh.json
// module id = MvI0
// module chunks = 1